module.exports = __webpack_public_path__ + "static/media/Logo_TBU_transparent.abc9060a.png";